(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("RLoginDPath", [], factory);
	else if(typeof exports === 'object')
		exports["RLoginDPath"] = factory();
	else
		root["RLoginDPath"] = factory();
})(this, function() {
return 